import React from 'react';

import CustomModal from 'components/CustomModal/CustomModal';

import { Button } from 'components/Button';

import { AcknowledgementRequestDetail } from 'utils/api/modules/entities/entities.types';

interface CancelRequestModalProps {
  open: boolean;
  cancelling: boolean;
  request: AcknowledgementRequestDetail | null;
  onClose: () => void;
  onConfirm: () => void;
}

const CancelRequestModal: React.FunctionComponent<CancelRequestModalProps> = ({
  open,
  cancelling,
  request,
  onClose,
  onConfirm,
}) => {
  const pending = request?.totals?.pending ?? 0;
  const acknowledged = request?.totals?.acknowledged ?? 0;

  return (
    <CustomModal
      openModal={open}
      onClose={cancelling ? undefined : onClose}
      modalTitle="Cancel this request?"
      modalDescription={
        `Pending acknowledgements for ${pending} recipient${pending === 1 ? '' : 's'} will be cancelled. ` +
        `The ${acknowledged} already recorded ${acknowledged === 1 ? 'is' : 'are'} preserved.`
      }
      cancelButton={
        <Button variant="outlined" size="large" onClick={onClose} disabled={cancelling}>
          Keep request
        </Button>
      }
      submitButton={
        <Button variant="contained" color="error" size="large" onClick={onConfirm} disabled={cancelling}>
          Cancel request
        </Button>
      }
    />
  );
};

export default CancelRequestModal;
